import { useDispatch } from 'react-redux';

import { GET_BOOKING_DETAILS_EMPTY } from '../../../../../../store/actions';
import { Constant } from '../../../../../Helpers/constant';

const StatusFilter = ({
  statusFilters,
  appliedStatusFilter,
  updateURLParams,
  setCurrentSelectedBooking,
  setCurrentActiveBookingAction,
  setWorkflowDisplayName,
  cardSummaryCount,
  setShouldHaveClearSelection,
  setSecondaryFiltersList,
  setAssignedToMeFilter,
}) => {
  const dispatch = useDispatch();

  const getTotalCount = (data, key) => {
    if (data?.[key] && data?.[key]?.data && typeof data?.[key]?.data?.totalCount === 'number') {
      return data?.[key]?.data?.totalCount ?? 0;
    }
    return 0;
  };

  return (
    <>
      <div className="horizontal-scrollor status-badge-wrapper">
        <div className="status-badge-container ">
          {statusFilters?.map((filter, index) => {
            return (
              <div
                className={`status-badge ${filter?.cardName === appliedStatusFilter ? 'active' : ''}`}
                key={index}
                onClick={() => {
                  setAssignedToMeFilter(false);
                  updateURLParams({ skip: 1, limit: Constant?.TABLE_PAGE_SIZE, appliedName: filter?.cardName, appliedType: filter?.cardType });
                  setCurrentSelectedBooking(null);
                  setCurrentActiveBookingAction(null);
                  setWorkflowDisplayName(filter?.displayName);
                  setSecondaryFiltersList(filter?.secondaryFilters ?? null);

                  setShouldHaveClearSelection(true);
                  setTimeout(() => {
                    setShouldHaveClearSelection(false);
                  }, 1000);

                  dispatch({
                    type: GET_BOOKING_DETAILS_EMPTY,
                  });
                }}
              >
                <p className="status-badge-text">
                  {filter?.displayName}({getTotalCount(cardSummaryCount, filter?.cardName)})
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default StatusFilter;
